module.exports = {"TXTCLI_How_it_worksX":{"id":"TXTCLI_How_it_worksX","defaultMessage":"Come funziona.","track":"How it works."}}